export default function EmojiRow() {
  const items = [
    { glyph: "\u221E", label: "Infinity" },
    { glyph: "\uD83C\uDF0E", label: "Earth" },
    { glyph: "\uD83D\uDCA1", label: "Idea" },
    { glyph: "\u2764\uFE0F", label: "Love" },
    { glyph: "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08", label: "Pride" },
  ];
  return (
    <div
      className="mt-12 flex items-center justify-center gap-5 sm:gap-7 text-2xl sm:text-3xl select-none"
      data-testid="emoji-row"
      aria-label="Anthony's values"
    >
      {items.map((it) => (
        <span
          key={it.label}
          role="img"
          aria-label={it.label}
          className="transition-transform duration-300 hover:scale-110"
        >
          {it.glyph}
        </span>
      ))}
    </div>
  );
}
